<template>
  <div
    class="best-practices-app"
    :class="{ open: showFilter, closed: !showFilter }"
  >
    <div class="facets-title">
      <h1>{{ bestPracticeLibraryLabel }}</h1>
    </div>
    <div
      ref="sidebar-facets"
      class="sidebar-left"
      :class="{ open: showFilter, closed: !showFilter }"
    >
      <div class="facets-title">
        <h1>{{ bestPracticeLibraryLabel }}</h1>
      </div>
      <div class="facets-data">
        <div class="search-bar">
          <md-field class="search">
            <label>Search library</label>
            <md-icon>search</md-icon>
            <md-input
              @keyup="searchBarTyping = true"
              @keyup.enter="
                searchBarTyping = false;
                goSearch();
              "
              v-model="searchBar"
            ></md-input>
            <md-button
              v-show="searchBarTyping == true"
              @click="
                searchBarTyping = searchBar == '' ? true : false;
                goSearch();
              "
              class="md-button search"
            >
              Search
              <md-icon>arrow_right_alt</md-icon>
            </md-button>
            <md-button
              v-show="searchBarTyping == false"
              @click="clearSearchResult()"
              class="md-icon-button clear"
            >
              <md-icon class="clear">close</md-icon>
            </md-button>
          </md-field>
          <md-button @click="toogleSidebar()" class="filter">
            <md-icon>filter_list</md-icon>
            <span>Filter</span>
            <md-icon class="close" :class="{ active: showFilter }"
            >close
            </md-icon
            >
          </md-button>
        </div>
        <div
          class="other-filters"
          :class="{ open: showFilter, closed: !showFilter }"
        >
          <div class="filters">
            <div
              class="data"
              :key="index"
              v-for="(facet, index) in facets_ordered"
            >
              <div
                class="facet-wrapper"
                :key="i"
                v-for="(item, i) in facet"
                :class="{ collapsed: collapsed[i] }"
              >
                <a @click="toggleFilterItem(i)">
                  {{ transformLabel(i) }}
                  <md-icon>{{
                      collapsed[i] ? "expand_less" : "expand_more"
                    }}
                  </md-icon>
                </a>
                <div class="facet" :class="i" v-show="collapsed[i]">
                  <md-checkbox
                    :ref="i + '_' + index"
                    :key="index"
                    v-for="(data, index) in item"
                    @change="updateData(data.url, i + '_' + index)"
                    v-model="data.values.active"
                    :value="data.values.value"
                  >{{ data.values.value }}
                  </md-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="actions">
            <md-button class="clear" v-on:click="clearSearchResult"
            >Reset
            </md-button
            >
            <md-button class="md-raised apply" v-on:click="applySearch"
            >Apply
            </md-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="results_count">
      <div class="count">
        {{ result_count }} Result{{ result_count > 1 ? "s" : "" }}
      </div>
      <div class="breadcrumbs">
        <div :key="index" v-for="(facet, index) in facets">
          <div class="breadcrumbs-group" :key="i" v-for="(item, i) in facet">
            <div :key="index" v-for="(data, index) in item">
              <div v-if="data.values.active" class="breadcrumb">
                <span>{{ data.values.value }}</span>
                <md-button class="md-icon-button" @click="updateData(data.url)">
                  <md-icon>close</md-icon>
                </md-button>
              </div>
            </div>
          </div>
        </div>
        <md-button
          v-if="breadcrumbs.length"
          class="clear"
          v-on:click="clearSearchResult"
        >Clear all
        </md-button
        >
      </div>
    </div>
    <div class="result">
      <activity-card v-for="item in searchResults" :key="item.nid" :item="item"></activity-card>
    </div>
    <spinner v-if="showLoader"></spinner>
  </div>
</template>

<script>
import _ from "lodash";
import Spinner from "./components/Spinner.vue";
import Submissions from "./Submissions";

export default {
  name: "BestPractices",
  mixins: [Submissions],

  computed: {
    result_count() {
      return this.total_items;
    },
    facets_ordered() {
      var ordering = {}, // map for efficient lookup of sortIndex
        sortOrder = [
          "field_language",
          "field_education_level",
          "field_subject",
          "field_aligned_competencies",
          "field_resource_type",
          "field_language_domain",
          "field_audience",
          "field_subgroup",
        ];
      for (var i = 0; i < sortOrder.length; i++) {
        ordering[sortOrder[i]] = i;
      }

      return this.facets
      .filter((el) => {
        if (el && Object.keys(el)[0] == "title") {
          return false;
        }
        return true;
      })
      .sort(function (a, b) {
        return (
          ordering[Object.keys(a)[0]] - ordering[Object.keys(b)[0]] ||
          Object.keys(a)[0].localeCompare(Object.keys(b)[0])
        );
      });
    },
  },
  components: {
    Spinner,
  },
  data() {
    return {
      collapsed: {},
      searchResults: [],
      likes: [],
      userLikes: [],
      current_page: null,
      total_items: null,
      facets: [],
      searchBar: "",
      searchBarTyping: true,
      baseUrl: '/rest/best-practices?_format=json',
      nids: [],
      showLoader: false,
      showFilter: false,
      small: false,
      pages: null,
      bestPracticeLibraryLabel:
      window.drupalSettings.group_catch_config.labels.best_practice_library,
    };
  },
  mounted() {
    let self = this;
    //Infinite scroll
    $(window).on("scroll", function() {
      let scrollHeight = $(document).height();
      let scrollPos = $(window).height() + $(window).scrollTop();
      if (((scrollHeight - scrollPos) / scrollHeight) < 0.2) {
        let current_page = self.current_page + 1;
        if (current_page != self.pages) {
          self.loadMore(current_page);
        }
      }
    });
    $(window).on("touchmove", function() {
      let scrollHeight = $(document).height();
      let scrollPos = $(window).height() + $(window).scrollTop();
      if (((scrollHeight - scrollPos) / scrollHeight) < 0.2) {
        let current_page = self.current_page + 1;
        if (current_page != self.pages) {
          self.loadMore(current_page);
        }
      }
    });
  },
  methods: {
    replaceUrlParam(url, paramName, paramValue) {
      if (paramValue == null) {
        paramValue = '';
      }
      var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
      if (url.search(pattern) >= 0) {
        return url.replace(pattern,'$1' + paramValue + '$2');
      }
      url = url.replace(/[?#]$/,'');
      return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
      },

    goTo(url) {
      window.location.href = url;
    },

    getFacetsSettings() {
      return window.drupalSettings.controller.group_settings.facets;
    },

    decorateFacets(facets) {
      let result = [];
      let facetsSettings = this.getFacetsSettings();
      let enabledFacets = [];
      let existingFacets = [];
      let existingFacetsStore = [];

      for (let facet in facets) {
        for (let item in facets[facet]) {
          if (!facets[facet][item].hasOwnProperty("#type")) {
            Object.keys(facets[facet][item]).forEach((key) => {
              facets[facet][item][key].forEach((value, index) => {
                if (
                  facets[facet][item][key][index].values.active &&
                  facets[facet][item][key][index].values.active == "true"
                ) {
                  facets[facet][item][key][index].values.active =
                    facets[facet][item][key][index].values.value;
                }
              });
            });
            Object.keys(facets[facet][item]).forEach((key) => {
              facets[facet][item][key].sort((a, b) => {
                if (a.values.value > b.values.value) {
                  return 1;
                }
                if (a.values.value < b.values.value) {
                  return -1;
                }
                return 0;
              });
            });
            existingFacets.push(facets[facet][item]);
          }
        }
      }
      for (let i in facetsSettings) {
        if (!(facetsSettings[i] == 0)) {
          enabledFacets.push(facetsSettings[i]);
        }
      }

      for (let i in enabledFacets) {
        existingFacets.filter((item) => {
          if (enabledFacets[i] == "title" && item.hasOwnProperty("title")) {
            result.push(item);
          }
          if (item.hasOwnProperty("field_" + enabledFacets[i]))
            result.push(item);
        });
      }
      return result;
    },

    goSearch() {
      let indeed = this.searchBar.toLowerCase();
      if (indeed) {
        let url =  this.replaceUrlParam(this.baseUrl, 'search', indeed);
        this.updateData(url);
      }
    },

    fetchInitialData() {
      this.showLoader = true;
      this.nids = [];
      this.baseUrl = '/rest/best-practices?_format=json';
      let options = {
        headers: {
          Accept: "application/json; odata=verbose",
          "Content-Type": "application/json",
          "cache-control": "no-cache",
        },
        credentials: "include",
        processData: false,
      };
      fetch("/rest/best-practices?_format=json", options)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        this.searchResults = data.search_results;

        data.search_results.map((item) => {
          this.nids.push(item.nid);
        });

        this.total_items = data.pager.total_items;
        this.pages = data.pager.total_pages;
        this.facets = this.decorateFacets(data.facets);
        this.current_page = data.pager.current_page;
        let params = this.getAllUrlParams(window.location.href);
        this.$router.push("/best-practices");
        if (params.s && params.s != "") {
          this.searchBar = decodeURIComponent(params.s);
          this.searchBarTyping = false;
          this.goSearch({key: "Enter"});
        }
        this.showLoader = false;
      })
      .then(() => {
        return this.updateLikes(
          _.map(this.searchResults, (item) => item.nid)
        );
      })
      .then(() => {
        this.searchResults = this.joinResults();
      })
      .catch(() => {
        this.showLoader = false;
      });
    },

    clearSearchResult() {
      this.searchBar = "";
      this.searchBarTyping = true;
      this.fetchInitialData();
      this.toogleSidebar(0);
    },

    loadMore(page) {
      if (this.showLoader) {
        return;
      }
      this.showLoader = true;
      let url =  this.replaceUrlParam(this.baseUrl, 'page', page)
      fetch(url)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        this.current_page = data.pager.current_page;
        data.search_results.map((item) => {
          if (!this.nids.includes(item.nid)) {
            this.nids.push(item.nid);
            this.searchResults.push(item);
          }
        });
        this.facets = this.decorateFacets(data.facets);
        this.showLoader = false;
      })
      .then(() => {
        return this.updateLikes(this.nids);
      })
      .then(() => {
        this.searchResults = this.joinResults();
      })
      .catch(() => {
        this.showLoader = false;
      });
    },

    updateData(url) {
      this.showLoader = true;
      this.baseUrl = url;
      this.nids = [];
      fetch(url)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        this.current_page = data.pager.current_page;
        this.searchResults = data.search_results;
        this.total_items = data.pager.total_items;
        this.pages = data.pager.total_pages;
        this.facets = this.decorateFacets(data.facets);
        this.showLoader = false;
        data.search_results.map((item) => {
          this.nids.push(item.nid);
        });
      })
      .then(() => {
        return this.updateLikes(
          _.map(this.searchResults, (item) => item.nid)
        );
      })
      .then(() => {
        this.searchResults = this.joinResults();
      })
      .catch(() => {
        this.showLoader = false;
      });
    },

    updateLikes(nids) {
      let options = {
        headers: {
          Accept: "application/json; odata=verbose",
          "Content-Type": "application/json",
          "cache-control": "no-cache",
        },
        credentials: "include",
        processData: false,
      };
      return fetch("/likes/" + _.join(nids, ","), options)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        this.likes = data;
      })
      .then(() => {
        return fetch("/user_likes", options);
      })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        this.userLikes = data;
      });
    },

    joinResults() {
      return _.map(this.searchResults, (item) => ({
        ...item,
        likes: _.has(this.likes, item.nid) ? _.get(this.likes, item.nid) : 0,
        liked: _.includes(this.userLikes, item.nid),
      }));
    },

    transformLabel: (field) => {
      var result = "";
      switch (field) {
        case "title":
          result = "Title";
          break;
        case "field_resource_type":
          result = "Resource Type";
          break;
        case "field_aligned_competencies":
          result = "Competency";
          break;
        case "field_education_level":
          result = "Grade Level";
          break;
        case "field_role":
          result = "Role";
          break;
        case "field_language":
          result = "Language";
          break;
        case "field_subject":
          result = "Subject";
          break;
        case "field_audience":
          result = "Audience";
          break;
        case "field_language_domain":
          result = "Language Domain";
          break;
        case "field_subgroup":
          result = "Subgroup";
          break;
      }
      return result;
    },
  },
};
</script>

<style lang="scss">
.best-practices {
  .fb-welcome {
    background-image: none !important;
    border-radius: 0px !important;
    box-shadow: none;
  }
}

.best-practices-app {
  position: relative;
}

.downscroll {
  .best-practices-app {
    .sidebar-left {
      transform: translate3d(0, 0, 0);

      &::before {
        background-position: bottom -300px right -10px;
      }

      &.open {
        .search-bar {
          max-height: 56px;
          opacity: 1;
        }
      }

      &.closed {
        h1 {
          text-align: center;
          font-size: 16px;
          margin: -10px 0px 10px;
          font-weight: normal;
        }
      }
    }

    .search-bar {
      max-height: 0;
      opacity: 0;

      &.closed {
        max-height: 56px;
      }

      &.open {
        max-height: 56px;
      }
    }
  }
}

.upscroll {
  .best-practices-app {
    .search-bar {
      max-height: 56px;
    }
  }
}

.best-practices-app {
  .results_count {
    @media all and (max-width: $breakpoint-medium) {
      padding-top: 120px;
    }
    //margin: 0 16px;
    .count {
      color: $title-blue;
      float: left;
      padding-right: 24px;
      padding-top: 5px;
      text-transform: uppercase;
    }

    &:after {
      display: block;
      content: "";
      clear: both;
    }
  }

  .breadcrumbs {
    @media all and (max-width: $breakpoint-medium) {
      display: none;
    }
    display: flex;
    flex-wrap: wrap;

    .breadcrumbs-group {
      display: flex;
      flex-wrap: wrap;
    }

    .clear.md-button.md-theme-default {
      color: $blue-dark;
      margin: 0;
      height: 29px;
      font-size: 18px;
      font-weight: bold;
    }

    .breadcrumb {
      font-family: $font-filson-soft;
      text-transform: uppercase;
      margin-right: 16px;
      margin-bottom: 10px;
      display: flex;
      background: $blue-dark;
      border-radius: 15px;
      padding: 4px 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: $white;

      .md-button.md-theme-default {
        margin-right: -4px;
        color: $white;
        font-size: 16px;

        .md-ripple {
          padding: 8px;
        }

        .md-icon {
          width: 16px;
          min-width: 16px;
          height: 16px;
          color: $white;
          font-size: 16px !important;
        }

        min-width: 20px;
        height: 20px;
        width: 20px;
      }
    }
  }

  @media all and (min-width: $breakpoint-medium) {
    &.open {
      &::before {
        content: "";
        display: block;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 99;
      }
    }
  }

  .actions {
    padding-bottom: 32px;
    padding-top: 32px;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    display: flex;
    text-align: center;
    max-width: 500px;
    margin: 0 auto;
    @media all and (max-width: $breakpoint-medium) {
      padding-top: 5px;
    }

    &::after {
      content: "";
      display: block;
      clear: both;
    }

    .clear {
      margin: 0 auto;
      color: rgb(255, 255, 255);
      font-size: 14px;
      font-weight: bold;
      font-family: $font-filson-soft;
    }

    .apply {
      margin: 0 auto;
      color: $blue-dark;

      &.md-theme-default.md-raised:not([disabled]) {
        font-size: 16px;
        font-family: $font-filson-soft;
        background: $white;
        color: $blue-dark;
      }
    }
  }

  .result {
    padding-top: 10px;
    background-color: transparent;
    @media all and (min-width: $breakpoint-medium) {
      margin: 0px -8px;
      //padding-top: 120px;
      padding-top: 20px !important;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  .search-bar {
    transition: $transition;
    transition: var(--transition);
    overflow: hidden;
    display: flex;
    max-height: 56px;

    .filter {
      height: 42px;
      margin: 0px 8px;
      min-width: 50px;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: normal;

      .md-button-content {
        color: $blue-dark;
        display: flex;
        flex-direction: column;
        @media all and (max-width: $breakpoint-medium) {
          color: $white;
          .md-icon {
            color: $white;
          }
        }
      }

      .md-icon {
        color: $blue-dark;

        &.close {
          position: absolute;
          display: none;
          border-radius: 50%;
          bottom: 19px;
          right: 4px;
          font-size: 12px !important;
          min-width: 12px;
          width: 12px;
          height: 12px;
          background-color: #f64536;
          border-radius: 50%;

          &.active {
            display: block;
          }
        }
      }
    }

    .search {
      @media all and (min-width: $breakpoint-medium) {
        max-width: inherit;
      }
    }
  }

  .other-filters {
    overflow: hidden;
    transition: $transition;
    transition: var(--transition);

    .filters {
      max-height: calc(100vh - 200px);
      overflow-y: auto;
      overflow-x: hidden;
      @media all and (min-width: $breakpoint-medium) {
        max-height: calc(100vh - 326px);
        display: flex;
        flex-wrap: wrap;
        overflow: visible;
        .data {
          width: 33%;
          padding-right: 16px;
          break-inside: avoid-column;
        }
      }
    }

    &.closed {
      max-height: 0px;
    }

    &.open {
      max-height: calc(100vh - 150px);
      @media all and (min-width: $breakpoint-medium) {
        max-height: calc(100vh - 278px);
        overflow: visible;
      }
    }
  }

  .search.md-field {
    margin: 0;
    margin-bottom: 16px;
  }

  .sidebar-left {
    transition: $transition;
    transition: var(--transition);
    overflow: hidden;
    position: fixed;
    @media all and (max-width: $breakpoint-medium) {
      top: 0;
      left: 0;
    }

    .facets-title {
      @media all and (max-width: $breakpoint-medium) {
        display: block;
      }
    }

    .md-field.search {
      .md-button.clear {
        display: none;
      }

      .md-button.search {
        @media all and (max-width: $breakpoint-medium) {
          display: none;
        }
        opacity: 1;
        border-radius: 0;
        color: $blue-dark !important;
        background-color: transparent;
        text-transform: uppercase;
        font-family: $font-filson-soft;
        font-weight: 300;
        font-size: 14px;

        &:hover {
          &::before {
            background-color: transparent;
          }

          background-color: transparent;
        }

        .md-icon {
          color: $blue-dark !important;
          display: block;
          opacity: 1;
        }

        .md-ripple {
          padding-right: 0px;
        }
      }
    }

    @media all and (min-width: $breakpoint-medium) {
      .facets-title {
        display: none;
      }
      h1 {
        font-size: 24px;
        line-height: 36px;
      }
      .facet.strategy {
        flex-basis: auto;
        margin: 0;
        max-width: 100%;
      }
      max-width: 1232px;
      width: 100%;
      overflow: visible;
      position: relative;
      // margin-left: -16px;
      // margin-right: -16px;
      .md-field.search {
        opacity: 0.7;

        &.md-focused {
          opacity: 1;

          .md-icon {
            opacity: 1;
          }
        }

        .md-icon {
          display: none;

          &.clear {
            display: block;
            color: $blue-dark !important;
            margin: 0;
          }
        }

        .md-button.clear {
          background: transparent;
          display: none;
        }

        &.md-has-value {
          .md-button.clear {
            opacity: 1;
            background: transparent;
            display: flex;
          }
        }

        label,
        input {
          padding-left: 0px;
          color: $blue-dark;
          font-size: 24px;
          font-family: $font-filson-soft;
          font-weight: normal;
          -webkit-text-fill-color: $blue-dark;
          margin: 0;
        }

        background-color: transparent;
        border-bottom: 1px solid $blue-dark;
        border-radius: 0px;
      }
      &.closed {
        z-index: 99;
        background-color: transparent;
        background-image: none;
        // padding: 20px 16px 0;
        // margin-left: -16px;
        // margin-right: -16px;
        &::before {
          background-image: none;
        }
      }
      &.open {
        position: fixed;
        z-index: 100;
        padding: 20px 16px 0;
        max-width: 1232px;
        @media all and (max-width: 1280px) {
          max-width: calc(100vw - 48px);
        }

        .md-button.filter {
          color: $white !important;

          .md-icon {
            color: $white !important;
          }

          .md-button-content {
            color: $white;
          }
        }

        .md-field.search {
          color: $white !important;
          border-bottom-color: $white;

          .md-icon {
            color: $white !important;
          }

          input,
          label {
            color: $white !important;
            -webkit-text-fill-color: #ffffff !important;
          }

          .md-button.search {
            color: $white !important;

            .md-icon {
              color: $white !important;
            }
          }
        }

        width: 100%;
      }
      padding: 20px 0px 0;
    }

    h1 {
      margin: 0 0px 10px;
      color: #ffffff;
    }

    // margin: -3px -5%;
    padding: 47px 30px 0;
    border-radius: 0px 0px 40px 40px;
    background-color: $blue-dark;

    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      background-image: url("./assets/book.svg");
      background-repeat: no-repeat;
      background-position: bottom -30px right -10px;
      border-radius: 40px;
    }

    width: 100%;
    z-index: 98;

    .facets-data {
      position: relative;

      &.opened {
        top: 0px;
      }
    }
  }

  .content {
    width: 100%;
  }

  .md-card {
    margin-bottom: 16px;
  }
}

.facet-wrapper {
  position: relative;
  border-radius: 20px;
  background-color: $white;
  margin-bottom: 16px;
  margin-top: 16px;

  a {
    display: block;
    text-transform: uppercase;
    cursor: pointer;
    color: rgb(60, 60, 60) !important;
    font-family: $font-filson-soft;
    font-size: 12px;
    line-height: 18px;
    padding: 10px 16px;

    .md-icon {
      float: right;
      width: 16px;
      height: 16px;
      font-size: 18px !important;
    }

    &:hover {
      text-decoration: none;
    }
  }

  &.collapsed {
    position: relative;
    width: 100%;
    z-index: 9999;
    @media all and (min-width: $breakpoint-medium) {
      position: absolute;
      width: 31%;
      border-radius: 20px 20px 20px 20px;
    }
  }

  & .facet {
    @media all and (min-width: $breakpoint-medium) {
      //position: absolute;
      width: 100%;
      background-color: $white;
      border-radius: 0px 0px 20px 20px;
      z-index: 99;
      max-height: 230px;
      overflow: auto;
    }

    .md-checkbox {
      width: 100%;
    }

    &.field_education_level {
      display: flex;
      flex-wrap: wrap;

      .md-checkbox {
        margin-right: 20px;
        float: left;
        width: auto;
      }
    }

    padding: 0px 16px 16px;
    margin-top: -10px;

    .md-checkbox {
      margin: 8px 0px 0px;

      .md-checkbox-container {
        width: 12px;
        min-width: 12px;
        height: 12px;
        top: 3px;

        &:after {
          width: 6px;
          height: 8px;
          top: -1px;
          left: 1px;
        }
      }
    }

    .md-checkbox-label {
      color: rgb(60, 60, 60);
      font-family: $font-source-sans-pro;
      font-size: 14px;
      font-weight: normal;
      line-height: 21px;
      padding-left: 8px;
    }

    .md-checkbox.md-theme-default .md-checkbox-container.md-checkbox-container {
      border-color: $blue-active;
    }

    .md-checkbox.md-theme-default.md-checked.md-checked .md-checkbox-container {
      border-color: $blue-active;
      background-color: $blue-active;
    }
  }
}
</style>

